import { CartLinesUpdateEvent } from '@shopify/events';

const tl = (kurus) => {
  const n = Number(kurus) / 100;
  const tam = Math.floor(n);
  const kr = Math.round((n - tam) * 100);
  return `${tam.toLocaleString('tr-TR')}${kr ? ',' + String(kr).padStart(2, '0') : ''} ₺`;
};

function isGunuEkle(gun) {
  const d = new Date();
  let kalan = gun;
  while (kalan > 0) {
    d.setDate(d.getDate() + 1);
    const g = d.getDay();
    const tatil = ['10-29', '1-1', '4-23', '5-1', '5-19', '7-15', '8-30'].includes(`${d.getMonth() + 1}-${d.getDate()}`);
    if (g !== 0 && g !== 6 && !tatil) kalan -= 1;
  }
  return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', weekday: 'long' });
}

class KitchUrun {
  constructor(kok) {
    this.kok = kok;
    this.$ = (s) => kok.querySelector(s);
    this.$$ = (s) => [...kok.querySelectorAll(s)];
    this.varyantlar = {};
    this.$$('[data-paket],[data-boy],[data-varyant-sec]').forEach((b) => { this.varyantlar[b.dataset.varyant] = { fiyat: b.dataset.fiyat, eski: Number(b.dataset.eski || 0), baslik: b.dataset.baslik }; });
    this.paketler();
    this.galeri();
    this.sabit();
    const tarih = this.$('[data-kargo-tarih]');
    if (tarih) tarih.textContent = `en geç ${isGunuEkle(Number(kok.dataset.gun || 3))}`;
    const form = this.$('[data-k-form]');
    form?.addEventListener('submit', (e) => { e.preventDefault(); this.sepete(); });
  }

  paketler() {
    const paketler = this.$$('[data-paket]');
    const sec = (el) => {
      paketler.forEach((p) => { p.classList.toggle('is-on', p === el); p.setAttribute('aria-checked', p === el); });
      const boy = el.querySelector('[data-boy].is-on');
      this.uygula(boy ? boy.dataset.varyant : el.dataset.varyant, el);
    };
    paketler.forEach((el) => {
      el.addEventListener('click', (e) => { if (!e.target.closest('[data-boy]')) sec(el); });
      el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sec(el); } });
      el.querySelectorAll('[data-boy]').forEach((b) => b.addEventListener('click', () => {
        el.querySelectorAll('[data-boy]').forEach((x) => x.classList.toggle('is-on', x === b));
        sec(el);
      }));
    });
    this.$$('[data-varyant-sec]').forEach((b) => b.addEventListener('click', () => {
      this.$$('[data-varyant-sec]').forEach((x) => x.classList.toggle('is-on', x === b));
      this.uygula(b.dataset.varyant);
    }));
    const ilk = paketler.find((p) => p.classList.contains('is-on'));
    if (ilk) sec(ilk);
  }

  uygula(id, paket) {
    this.$('[data-varyant-id]').value = id;
    const v = this.varyantlar[id];
    if (!v) return;
    if (paket) { const fe = paket.querySelector('[data-paket-fiyat]'); if (fe) fe.textContent = tl(v.fiyat); }
    this.$('[data-fiyat]').textContent = tl(v.fiyat);
    this.$('[data-sabit-fiyat]').textContent = tl(v.fiyat);
    const eski = this.$('[data-eski]'); const ind = this.$('[data-indirim]');
    const indirimli = v.eski > Number(v.fiyat);
    if (eski) { eski.hidden = !indirimli; ind.hidden = !indirimli; if (indirimli) { eski.textContent = tl(v.eski); ind.textContent = `%${Math.floor(((v.eski - v.fiyat) * 100) / v.eski)} indirim`; } }
    const pe = paket?.querySelector('[data-paket-eski]');
    if (pe && indirimli) pe.textContent = tl(v.eski);
    this.$$('[data-secim-ozet],[data-sabit-ad]').forEach((e) => { e.textContent = v.baslik; });
  }

  async sepete() {
    const btn = this.$('[data-sepete]');
    const hata = this.$('[data-hata]');
    hata.hidden = true;
    const id = this.$('[data-varyant-id]').value;
    const items = [{ id: Number(id), quantity: 1 }];
    const bolumler = [...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean);
    btn.disabled = true;
    const kok = window.Shopify?.routes?.root || '/';
    const ertelenen = CartLinesUpdateEvent.createPromise();
    this.kok.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: ertelenen.promise }));
    try {
      const yanit = await fetch(`${kok}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: bolumler.join(',') }),
      }).then((r) => r.json());
      const sepet = await fetch(`${kok}cart.js`).then((r) => r.json());
      const detail = { items: sepet.items, source: 'kitch-urun', sourceId: this.kok.id, itemCount: 1, productId: String(this.kok.dataset.urun), sections: yanit.sections, didError: Boolean(yanit.status) };
      ertelenen.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(sepet), detail });
      if (yanit.status) { hata.textContent = yanit.description || yanit.message || 'Sepete eklenemedi, tekrar dene.'; hata.hidden = false; return; }
      if (!document.querySelector('cart-drawer-component')) window.location.href = `${kok}cart`;
    } catch (e) {
      ertelenen.reject(e);
      hata.textContent = 'Bağlantı sorunu oldu, tekrar dene.';
      hata.hidden = false;
    } finally {
      btn.disabled = false;
    }
  }

  galeri() {
    const ana = this.$('[data-galeri-ana]');
    if (!ana) return;
    const kareler = [...ana.children];
    const kucukler = this.$$('[data-kucuk]');
    const sayac = this.$('[data-sayac]');
    const isaretle = (i) => {
      kucukler.forEach((k, j) => k.classList.toggle('is-on', j === i));
      if (sayac) sayac.textContent = `${i + 1} / ${kareler.length}`;
      this.aktif = i;
    };
    const git = (i) => {
      const n = (i + kareler.length) % kareler.length;
      ana.scrollTo({ left: kareler[n].offsetLeft - ana.offsetLeft, behavior: 'smooth' });
      isaretle(n);
    };
    this.aktif = 0;
    ana.addEventListener('scroll', () => isaretle(Math.round(ana.scrollLeft / ana.clientWidth)), { passive: true });
    kucukler.forEach((k) => k.addEventListener('click', () => git(Number(k.dataset.kucuk))));
    this.$$('[data-ok]').forEach((b) => b.addEventListener('click', () => git(this.aktif + Number(b.dataset.ok))));
  }

  sabit() {
    const s = this.$('[data-sabit]');
    const btn = this.$('[data-sepete]');
    if (!s || !btn) return;
    const io = new IntersectionObserver(([g]) => {
      const goster = !g.isIntersecting && g.boundingClientRect.top < 0 && window.scrollY > 400;
      s.classList.toggle('is-on', goster);
      s.setAttribute('aria-hidden', String(!goster));
      s.querySelector('[data-sabit-btn]').tabIndex = goster ? 0 : -1;
    });
    io.observe(btn);
    window.addEventListener('scroll', () => { const r = btn.getBoundingClientRect(); const goster = r.bottom < 0 && window.scrollY > 400; s.classList.toggle('is-on', goster); s.setAttribute('aria-hidden', String(!goster)); }, { passive: true });
    s.querySelector('[data-sabit-btn]').addEventListener('click', () => this.sepete());
  }
}

document.querySelectorAll('[data-k-urun]').forEach((k) => { if (!k.kitch) k.kitch = new KitchUrun(k); });

